import { render, staticRenderFns } from "./CoproducerProducts.vue?vue&type=template&id=076ad902&"
import script from "./CoproducerProducts.vue?vue&type=script&lang=js&"
export * from "./CoproducerProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports